import classnames from "classnames";
import { useRouter } from "next/router";

import Img from "@components/FileServer/Img";

type Props = {
  maxTransfers: number | "direct";
  propsMaxTransfers: number | "direct";
  changeFilter: (params: any) => void;
};

const FilterTransfers = ({
  maxTransfers,
  propsMaxTransfers,
  changeFilter,
}: Props) => {
  const { query } = useRouter();

  const minusClick = () => {
    if (maxTransfers > 0 && maxTransfers !== "direct")
      changeFilter({
        target: {
          name: "max_transfers",
          value: maxTransfers - 1,
        },
      });
  };

  const plusClick = () => {
    if (query.max_transfers === "direct") {
      changeFilter({
        target: {
          name: "max_transfers",
          value: undefined,
        },
      });
      return;
    }

    if (maxTransfers < propsMaxTransfers) {
      if (maxTransfers !== "direct")
        changeFilter({
          target: {
            name: "max_transfers",
            value: maxTransfers + 1,
          },
        });
    }
  };

  const value = !!maxTransfers && maxTransfers === "direct" ? 0 : maxTransfers;
  const valueText = `max. ${value}`;

  const minusClasses = classnames(
    "header-search-form-additional-bottom-tolerance-minus",
    {
      "header-search-form-additional-bottom-tolerance--disabled": value === 0,
    }
  );

  const plusClasses = classnames(
    "header-search-form-additional-bottom-tolerance-plus",
    {
      "header-search-form-additional-bottom-tolerance--disabled":
        propsMaxTransfers === null || value === propsMaxTransfers,
    }
  );

  return (
    <div className="filters-transfers">
      <Img
        className={minusClasses}
        src="/static/images/ico-minus.svg"
        onClick={minusClick}
        id="filters-tolerance-minus"
        alt="minus icon"
      />
      <Img
        className={plusClasses}
        src="/static/images/ico-plus.svg"
        onClick={plusClick}
        id="filters-tolerance-plus"
        alt="plus icon"
      />
      {valueText}
    </div>
  );
};

export default FilterTransfers;
